/**
 * Turns off zod's JIT in the browser. Imported first by
 * `instrumentation-client.ts`, which Next runs before any app code.
 *
 * zod v4 compiles a fast object parser with `new Function(...)` and, the
 * first time any `z.object` is constructed, probes for that with
 * `new Function("")` (`allowsEval` in zod/v4/core/util.js). Both are `eval`
 * to CSP: the Report-Only policy reported them from survey and invite pages,
 * and an enforced `script-src` without `'unsafe-eval'` would make every
 * page that builds a schema report a violation (CSP step 1, Oct 2026).
 * `jitless` skips the probe and the codegen; parsing still works, on the
 * interpreted path. The setting is read when a schema is constructed, so it
 * has to run before any module that defines one, which is why it lives
 * here and not in a layout.
 */
import { config } from "zod";

config({ jitless: true });
